import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app"
import '../../node_modules/firebase/compat/firestore';
import { getDoc, doc } from "firebase/firestore";
import { firebaseConfig } from "../firebase-config";

import NavbarDefault from "./components/navbarDefault";
import FooterDefault from "./components/footerDefault";
import InstantMessage from './InstantMessage.js';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { createTheme, responsiveFontSizes } from "@mui/material";
import { ThemeProvider } from "@emotion/react";

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function CheckTicket() {
  const [val, setVal] = useState("1")
  const navigate = useNavigate();
  
  // FOR ERROR ALERT MESSAGE
  const [instant, setInstant] = useState(false); // Controls Alert
  const [severity, setSeverity] = useState(''); // Controls Severity
  const [message, setMessage] = useState('') // Controls Message
  
  function fetchSingle(e){
    e.preventDefault();
    firebase.initializeApp(firebaseConfig);
    const db = firebase.firestore();
    getDoc(doc(db, "tickets", val)).then(docSnap => {
      if (docSnap.exists()) {
        navigate(`/TicketStatus/${val}`)
      } else {
        // FOR ERROR ALERT MESSAGE
        setMessage("Invalid Ticket ID! Try again.")
        setSeverity("error")
        setInstant(true); // Turn On Alert so it displays
      }
    })
    // FOR ERROR ALERT MESSAGE
    setInstant(false); // Very important to set this back to off
  }

  const buttonStyle = { mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}};

  return (
    <ThemeProvider theme={theme}>

      {/* NAVIGATION BAR */}
      <NavbarDefault /> 

      <Box style={{ display:'flex', justifyContent:'center' }}>
        <Grid sx={{mt:12, mb:15}}>
          <Card sx={{boxShadow:5, mb:3}} style={{ maxWidth: 450, padding: "10px 10px", margin: "0 auto", justifyContent:'center' }}>
            <CardContent>
              {instant ?  <InstantMessage sev = {severity} message = {message} /> : `` }
              <Typography fontWeight="bold" component="h1" variant="h5" align="center" sx={{ mt: 1}}>
                CHECK TICKET STATUS
              </Typography>
              <Typography component="h1" variant="body1" align="center" sx={{ mt: 3, mb: 1 }}>
                Use this tool to track the status of a help request ticket you have previously submitted.
              </Typography>

              <Typography fontWeight="bold" component="h1" variant="body1" align="center" sx={{ mt: 5, mb: 1 }}>
                Enter a Ticket ID
              </Typography>

              {/* TEXT INPUT FIELD */}
              <TextField fullWidth id="outlined-basic" label="Ticket ID" variat="outlined" onChange = {(event) => setVal(event.target.value)}/>
              
              {/* CHECK STATUS BUTTON */}
              <Button type="submit" variant="contained" sx={buttonStyle} fullWidth onClick={fetchSingle}>
                Check Status
              </Button>
              
              <Typography component="h1" variant="caption" align="center" sx={{ mt: 1 }}>
                Forgot your Ticket ID? Check your email!
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Box>  

      {/* FOOTER NAVIGATION */}
      <FooterDefault /> 

    </ThemeProvider>
  );
}

export default CheckTicket